import {Store} from 'client/framework';
import {fromJS} from 'immutable';
import {confirmChangesModalActions} from './ConfirmChangesModal.actions';

export class confirmChangesModalStore extends Store {
  constructor(name) {
    super(name);

    this.initialData = fromJS({
      showModal: false
    });

    this.setInitialData(this.initialData);
    this.handleTargeted(confirmChangesModalActions.TOGGLE_MODAL, this.setProperty('showModal'));
  }

  showModal() {
    return this.readData('showModal');
  }
}
